// extracted by mini-css-extract-plugin
export var boxItems = "_8g-1";
export var button = "_8g-5";
export var filterGroupBox = "_8g-0";
export var icon = "_8g-2";
export var iconSecondary = "_8g-4";
export var iconWrapper = "_8g-3";